import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { fetchAllUsers } from "../services/adminService";
import { handleApiError } from "../utils/errorHandler";
import CustomTable from "./CustomTable";
import StatisticsExport from "./StatisticsExport";

export default function AllUsers(props) {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [exportModalVisible, setExportModalVisible] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const result = await fetchAllUsers();
      if (result.success) {
        setUsers(result.data);
      } else {
        setError(handleApiError(result));
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  // Filtered data based on search term
  const filteredData = users.filter(
    (row) =>
      row.cisloOdberatele.includes(searchTerm.toLowerCase()) ||
      row.nazev.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.ic.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.adresa.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (row.emailOrsoft || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (row.emailMfa || row.email || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  return (
    <>
      <TextField
        label="Hledat"
        variant="outlined"
        margin="normal"
        value={searchTerm}
        onChange={handleSearchChange}
        sx={{ maxWidth: "50%" }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      <CustomTable
        columns={props.customerColumns}
        data={filteredData}
        onRowClick={props.handleRowClick}
        getRowKey={(row) => row.cisloOdberatele}
        cursor={true}
      />

      <StatisticsExport
        exportModalVisible={exportModalVisible}
        setExportModalVisible={setExportModalVisible}
      />
    </>
  );
}
